import { render, staticRenderFns } from "./BoardTenure.vue?vue&type=template&id=32c0f3cb"
import script from "./BoardTenure.vue?vue&type=script&lang=ts"
export * from "./BoardTenure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports